import React from "react";
import OtpInput from "react-otp-input";
import { Stack, Typography, useTheme } from "@mui/material";
import { Controller, Control, RegisterOptions } from "react-hook-form";

interface RHFOtpVerifyProps {
  name: string;
  control?: Control<any>;
  rules?: RegisterOptions;
  numInputs?: number;
  inputStyle?: React.CSSProperties;
}

export const RHFOtpVerify = ({
  name,
  control,
  rules,
  numInputs = 4,
  inputStyle,
}: RHFOtpVerifyProps) => {
  const theme = useTheme();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <Stack alignItems="center" spacing={1} sx={{ width: "100%" }}>
          <OtpInput
            value={field.value || ""}
            onChange={field.onChange}
            numInputs={numInputs}
            renderInput={(props) => (
              <input
                {...props}
                style={{
                  width: 40,
                  height: 40,
                  margin: "0 8px",
                  textAlign: "center",
                  fontSize: 18,
                  border: error
                    ? `1px solid ${theme.palette.error.main}`
                    : "none",
                  borderRadius: 8,
                  backgroundColor: theme.palette.grey[200],
                  outline: "none",
                  ...inputStyle,
                }}
              />
            )}
          />
          {error && (
            <Typography
              variant="caption"
              color="error.main"
              sx={{ textAlign: "center", mt: 0.5 }}
            >
              {error.message}
            </Typography>
          )}
        </Stack>
      )}
    />
  );
};

